import React from 'react';
import '../../components/DBOSHomepage.css';
import '../SmartWeb.css';
import './Legal.css';

const Cookies = () => {
  return (
    <div className="legal-page">
      <header className="header">
        <div className="container">
          <a href="/" className="logo">
            <span className="logo-text shimmering">DBOS.world</span>
          </a>
        </div>
      </header>
      <main className="legal-content">
        <div className="container">
          <h1>Cookie Policy</h1>
          <p className="version-info">V1.0 | 03/03/2026</p>
          
          <section className="legal-section">
            <h2>Types of Cookies</h2>
            <p><strong>Strictly Necessary:</strong> Security, forms, sessions (cannot be disabled)</p>
            <p><strong>Analytics:</strong> Google Analytics, Microsoft Clarity (requires consent)</p>
            <p><strong>Payment:</strong> Stripe processing cookies</p>
          </section>

          <section className="legal-section">
            <h2>Managing Cookies</h2>
            <p>Manage cookies in your browser settings. Disabling may impact functionality.</p>
          </section>

          <div className="legal-footer">
            <p><a href="/legal/terms">Terms</a> | <a href="/legal/privacy">Privacy</a> | <a href="/legal/dpa">DPA</a></p>
            <a href="/" className="btn-back">← Back to Home</a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Cookies;
